import React, { Component } from 'react';
import './App.css';
import { Button, ButtonDropdown, DropdownItem, DropdownToggle, DropdownMenu, Table, ListGroup, ListGroupItem, Container, Row, Col } from 'reactstrap';
import {Line,Pie,Bar} from 'react-chartjs-2';
import Script from 'react-load-script';


var datosPartidos = {1:[1,1.5,1.35,3,1.8],2:[1,1,1.2,0,1.8],3:[1,1.5,1.35,3,1.8],4:[1,1,0.75,0,1.8]};
var textosColumnas = ['Santiago Flores Alfaro','Lorena Guadalupe Peña Mendoza','Yolanda Aida Herrera Morán','Karina Ivette Sosa','Guillermo Francisco Mata Bennett']


class Ficha extends Component {
  render(){
    return (
          <ListGroupItem key={this.props.id} onClick={() => this.props.onClick()}>{this.props.name}</ListGroupItem>
    );
  }
}

class Tabla extends Component {
  render(){
    if (this.props.partido == -1){
      return null;
    }
    return (
          <Table responsive>
            {textosColumnas.map((texto,indice) => {
              return (<tr>
                <td>{texto}</td>
                <td>{datosPartidos[this.props.partido][indice]}</td>
              </tr>
            )})}
          </Table>
    );
  }
}

class App extends Component {
  constructor(props){
    super(props);
    this.state = {textoBuscador:'',datosAnuales:{},partidosMostrados:[],partidoActual:-1,nombrePartidoActual: '', dropdownOpen: false, añoActual: '', datosGraficoGlobal: [], datosListos: false};

    this.handleChangeBuscador= this.handleChangeBuscador.bind(this);
    this.datosGraficoGlobal = this.datosGraficoGlobal.bind(this);
    this.datosGraficoBarra = this.datosGraficoBarra.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentWillMount(){
    let API = 'https://sheets.googleapis.com/v4/spreadsheets/1qCaNNnJwNayiCOZK2Fti3N_2TxbRui7oiEMyazE3JMc/values:batchGet?ranges=general!A1:J999999&majorDimension=ROWS&key=AIzaSyAiHkA-KeshKgRHuxzdIAD64dJ_QAK0RrA'
    let API2 = 'https://sheets.googleapis.com/v4/spreadsheets/1qCaNNnJwNayiCOZK2Fti3N_2TxbRui7oiEMyazE3JMc/values:batchGet?ranges=tipo_eleccion!A1:J999999&majorDimension=ROWS&key=AIzaSyAiHkA-KeshKgRHuxzdIAD64dJ_QAK0RrA'
    fetch(API).then(response => response.json())
    .then(data => {

      let datos = {};
      data.valueRanges[0].values.shift();
      data.valueRanges[0].values.map(fila => {

        if (!datos.hasOwnProperty(fila[0])){
          datos[fila[0]] = {};
          datos[fila[0]][fila[1]] = {};
          datos[fila[0]][fila[1]][fila[2]] = {};
          datos[fila[0]][fila[1]][fila[2]][fila[3]] = fila.slice(4,fila.length);

        } else if (!datos[fila[0]].hasOwnProperty(fila[1])) {
          datos[fila[0]][fila[1]] = {};
          datos[fila[0]][fila[1]][fila[2]] = {};
          datos[fila[0]][fila[1]][fila[2]][fila[3]] = fila.slice(4,fila.length);

        } else if (!datos[fila[0]][fila[1]].hasOwnProperty(fila[2])) {
          datos[fila[0]][fila[1]][fila[2]] = {};
          datos[fila[0]][fila[1]][fila[2]][fila[3]] = fila.slice(4,fila.length);

        } else if (!datos[fila[0]][fila[1]][fila[2]].hasOwnProperty(fila[3])) {
          datos[fila[0]][fila[1]][fila[2]][fila[3]] = fila.slice(4,fila.length);

        }

      });
      this.setState({datosAnuales: datos, datosListos: true});


    })

    fetch(API2).then(response => response.json())
    .then(data => {

      let datos = {};
      data.valueRanges[0].values.shift();
      data.valueRanges[0].values.map(fila => {

        if (!datos.hasOwnProperty(fila[0])){
          datos[fila[0]] = {};
          datos[fila[0]][fila[1]] = {};
          datos[fila[0]][fila[1]][fila[2]] = {};
          datos[fila[0]][fila[1]][fila[2]][fila[3]] = fila.slice(4,fila.length);

        } else if (!datos[fila[0]].hasOwnProperty(fila[1])) {
          datos[fila[0]][fila[1]] = {};
          datos[fila[0]][fila[1]][fila[2]] = {};
          datos[fila[0]][fila[1]][fila[2]][fila[3]] = fila.slice(4,fila.length);

        } else if (!datos[fila[0]][fila[1]].hasOwnProperty(fila[2])) {
          datos[fila[0]][fila[1]][fila[2]] = {};
          datos[fila[0]][fila[1]][fila[2]][fila[3]] = fila.slice(4,fila.length);

        } else if (!datos[fila[0]][fila[1]][fila[2]].hasOwnProperty(fila[3])) {
          datos[fila[0]][fila[1]][fila[2]][fila[3]] = fila.slice(4,fila.length);

        }

      });
      console.log(datos);
      this.setState({datosAnualesSecundarios: datos, datosListos: true});


    })

  }

  componentDidMount(){
    if (this.state.datosListos){
      this.setState({datosGraficoGlobal: this.datosGraficoGlobal('2019')});
    }

  }

  handleChangeBuscador(event){
    var searchQuery = event.target.value.toLowerCase();
    let displayedParties = [];
        for (let year in this.state.datosAnuales){
          for (let partido in this.state.datosAnuales[year]){

            let searchValue = partido.toLowerCase()+' '+year.toLowerCase();
            if (searchValue.indexOf(searchQuery) !== -1) {
              displayedParties.push({name: searchValue.toUpperCase(), añoActual: year, party: partido});
            }
          }

        }


    this.setState({partidosMostrados: displayedParties,textoBuscador:event.target.value});
  }

  handleClickFicha(id,nombre,año){
    this.setState({partidosMostrados: [],textoBuscador:'',partidoActual:id,nombrePartidoActual:nombre, añoActual:año });
  }

  handleCargar(){
    console.log(this.state.datosAnuales);
    let ultimo = Math.max(...Object.keys(this.state.datosAnuales));
    this.setState({partidoActual: 'Global',añoActual: ultimo});
  }

  toggle() {
      this.setState({
        dropdownOpen: !this.state.dropdownOpen
      });
    }

    datosGraficoGlobal(año){
      let acumulado = [[],[],[]];

      for(let partido in this.state.datosAnuales[año]){
        if (partido === 'Global') continue;
        console.log(partido);
        acumulado[0].push(partido);
        let sumador = 0; let color = '';
        for (let mes in this.state.datosAnuales[año][partido]){
          console.log(this.state.datosAnuales[año][partido][mes]);
          for (let medio in this.state.datosAnuales[año][partido][mes]){
            sumador += parseFloat(this.state.datosAnuales[año][partido][mes][medio][2]);
            color = this.state.datosAnuales[año][partido][mes][medio][4]
          }
        }
        acumulado[1].push(sumador);
        acumulado[2].push(color);
      }
      console.log(acumulado);
      let resultado  = {
        labels: acumulado[0],
        datasets: [
          {
            label: 'Todos los partidos',
            data: acumulado[1],
            fill: false,
            backgroundColor: acumulado[2]
          }
        ]
      }
      return resultado;
    }

    datosGraficoPastel(año){
      let acumulado = [[],[],[]];

        let medios = {}
        let sumador = 0; let color = '';
        for (let mes in this.state.datosAnuales[año][this.state.partidoActual]){
          for (let medio in this.state.datosAnuales[año][this.state.partidoActual][mes]){
            let partido = this.state.datosAnuales[año][this.state.partidoActual][mes][medio][1];
            if (!medios.hasOwnProperty(partido))  {
              medios[partido] ={};
              medios[partido]['valor'] = 0;
            }
            medios[partido]['valor'] += parseFloat(this.state.datosAnuales[año][this.state.partidoActual][mes][medio][2]);
            medios[partido]['color'] = this.state.datosAnuales[año][this.state.partidoActual][mes][medio][4]
          }
        }
        for (let medio in medios){
          acumulado[0].push(medio);
          acumulado[1].push(medios[medio]['valor']);
          acumulado[2].push(medios[medio]['color']);
        }


      console.log(acumulado);
      let resultado  = {
        labels: acumulado[0],
        datasets: [
          {
            data: acumulado[1],
            fill: false,
            backgroundColor: acumulado[2]
          }
        ]
      }
      return resultado;


    }

    datosGraficoPastel2(año){
      let acumulado = [[],[],[]];

        let medios = {}
        let sumador = 0; let color = '';
        for (let mes in this.state.datosAnualesSecundarios[año][this.state.partidoActual]){
          for (let medio in this.state.datosAnualesSecundarios[año][this.state.partidoActual][mes]){

            let partido = this.state.datosAnualesSecundarios[año][this.state.partidoActual][mes][medio][1];
            if (!medios.hasOwnProperty(partido))  {
              medios[partido] ={};
              medios[partido]['valor'] = 0;
            }
            medios[partido]['valor'] += parseFloat(this.state.datosAnualesSecundarios[año][this.state.partidoActual][mes][medio][2]);
            medios[partido]['color'] = this.state.datosAnualesSecundarios[año][this.state.partidoActual][mes][medio][3]
          }
        }
        for (let medio in medios){
          acumulado[0].push(medio);
          acumulado[1].push(medios[medio]['valor']);
          acumulado[2].push(medios[medio]['color']);
        }


      console.log(acumulado);
      let resultado  = {
        labels: acumulado[0],
        datasets: [
          {
            data: acumulado[1],
            fill: false,
            backgroundColor: acumulado[2]
          }
        ]
      }
      return resultado;


    }

    datosGraficoBarra(año){
      let acumulado = [[],[],[]];
      console.log(año);
        let medios = {}
        let sumador = 0; let color = '';
        for (let mes in this.state.datosAnualesSecundarios[año][this.state.partidoActual]){

          for (let medio in this.state.datosAnualesSecundarios[año][this.state.partidoActual][mes]){
            let partido = this.state.datosAnualesSecundarios[año][this.state.partidoActual][mes][medio][0];
            if (!medios.hasOwnProperty(partido))  {
              medios[partido] ={};
              medios[partido]['valor'] = 0;
            }
            console.log(this.state.datosAnualesSecundarios[año][this.state.partidoActual][mes][medio][2]);
            medios[partido]['valor'] += parseFloat(this.state.datosAnualesSecundarios[año][this.state.partidoActual][mes][medio][2]);
            medios[partido]['color'] = this.state.datosAnualesSecundarios[año][this.state.partidoActual][mes][medio][3];
          }
        }
        for (let medio in medios){
          acumulado[0].push(medio);
          acumulado[1].push(medios[medio]['valor']);
          acumulado[2].push(medios[medio]['color']);
        }



      let resultado  = {
        labels: acumulado[0],
        datasets: [
          {
            label: 'Montos mes a mes',
            data: acumulado[1],
            fill: false,
            backgroundColor: acumulado[2]
          }
        ]
      }
      return resultado;


    }


  render() {


    const data_segmentos = {
      labels: [
        'Televisión', 'Radio', 'Prensa'
      ],
      datasets: [
        {
          data: [2435917.14,352949.50,301865.28],
          backgroundColor: ['#0029ff','#6b83ff','#6b8300']
        }
      ]
    }

    const data_eleccion = {
      labels: [
        'Diputados', 'Alcaldes', 'Partido'
      ],
      datasets: [
        {
          data: [385728.23,835456.51,1869547.18],
          backgroundColor: ['#0029ff','#6b83ff','#6b8300']
        }
      ]
    }


    const data = {
      labels: [
        'Octubre', 'Noviembre',
        'Diciembre', 'Enero'
      ],
      datasets: [
        {
          label: 'Global',
          data: [33656037.86,26610522.09,4715233.09,13070662.53],
          fill: false,
          backgroundColor: '#3051fc',
          borderColor: '#3051fc'
        }
      ]
    }

    const data3 = {
      labels: [
        'ARENA', 'CD',
        'FMLN', 'GANA'
      ],
      datasets: [
        {
          label: 'Global',
          data: [33656037.86,26610522.09,4715233.09,13070662.53],
          fill: false,
          backgroundColor: ['#3051fc','#305100','#3ff1fc'],
          borderColor: '#3051fc'
        }
      ]
    }


    const options = {
      maintainAspectRatio: true,
      legend:{
        display: true,
      },
      tooltips: {
                callbacks: {
                    label: function(tooltipItem, data) {
                          return 'Monto: $'+ parseFloat(data.datasets[0].data[tooltipItem.index]).toLocaleString("es-MX");
                     }
               }
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                callback: function(value, index, values) {
                  return value.toLocaleString("es-MX");
                }
              }
            }]
          }
    }
    return (
      <div className="App">
        {Object.entries(this.state.datosAnuales) != 0 &&
          <Script url="./dummy.js"
            onLoad={this.handleCargar.bind(this)}
          />
        }
        <Container>
          <Row>
            <Col sm="12">
              <p>Los datos que se presentan son los resultados del monitoreo a la propaganda electoral en radio, prensa escrita, televisión y vallas publicitarias en el periodo permitido por la Constitución de la República y el Código Electoral.</p>
              <p>Ingresa el nombre del partido y haz clic sobre el año del que quieres ver los datos de la propaganda electoral.</p>
              <input className="form-control" type="search" placeholder="Nombre del partido..." value={this.state.textoBuscador} onChange={this.handleChangeBuscador} />
              <ListGroup>
                {this.state.partidosMostrados.map((el) => {
                  return <Ficha name={el.name}  onClick={() => this.handleClickFicha(el.party,el.name,el.añoActual)} />;
                })}
              </ListGroup>
            </Col>
          </Row>
          <Row>
            <Col sm="8">
              { this.state.partidoActual !== -1 &&
                <div>
                  <p>En este gráfico puedes ver el valor monetario acumulado por todos los partidos políticos para el año {this.state.añoActual}.</p>
                  <Bar data={this.datosGraficoGlobal(this.state.añoActual)} height={150} options={options} />
                </div>
              }


            </Col>
            <Col sm="4">
              <h6>Desgloce de datos</h6>
              <p className='centrar'>{this.state.partidoActual == 'Global' && <p>Aquí puedes ver los datos de la propaganda electoral de todos los partidos políticos por medio de comunicación.</p>}
              {(this.state.partidoActual != 'Global' && this.state.partidoActual !== -1 ) && <p>Aquí puedes ver los datos de la propaganda electoral del partido {this.state.partidoActual} por medio de comunicación.</p>}
              </p>

              {(this.state.partidoActual != -1 && this.state.partidoActual != 1 ) &&
                <Pie data={this.datosGraficoPastel(this.state.añoActual)} options={options} />
              }
            </Col>
          </Row>
        </Container>
        <Container className="canvas-container">
          <p style={{fontSize:'18px'}}>Datos por mes y tipo de campaña para el año {this.state.añoActual}</p>

        </Container>
        <Container className="canvas-container">
        <Row>
          <Col sm="6">
            {this.state.partidoActual !== -1  &&
              <Bar data={this.datosGraficoBarra(this.state.añoActual)} height={150} options={options} />
            }
          </Col>
          <Col sm="6">
            {this.state.partidoActual !== -1  &&
              <Pie data={this.datosGraficoPastel2(this.state.añoActual)} options={options} />
            }
          </Col>
        </Row>


          </Container>

        <hr />

      </div>
    );
  }
}

export default App;
